"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteBucketOutput = {
    type: "structure",
    required: [],
    members: {}
};
//# sourceMappingURL=DeleteBucketOutput.js.map